export const PAYMENT = 'user/payment';
export const ORDER_QUERY = 'order/query';